export const routes = {
  oDataRoute: 'Mmc/v3/',
  plainRoute: 'api/v1/',
};

export const endpoints = {
  campaignStores: '',
  stores: '',
  hasPlaceholderStore: 'Stores/HasPlaceholderStores',
  getPlaceholderStores: 'Stores/GetPlaceholderStores',
  upgradePlaceholdrStore: 'Stores/UpgradePlaceholderStore',
  createStoreForPlaceholderStore: 'Stores/UpgradePlaceholderToNewStore',
  getGmcStores: 'GoogleMerchantStores',
  storesWithGmcCreds: 'StoreWithGmcCreds',
  upgradePlaceholderStoreWithGmcStore: 'StoreWithGmcCreds/UpgradePlaceholderStoreWithGmcStore',
  getDomains: 'Stores/',
  validateCreateParams: 'Stores/',
  feeds: sid => `Stores(${sid})/Feeds`,
  feedUploads: (sid, fid) => `Stores(${sid})/Feeds(${fid})/GetFeedUploads`,
  uploadLink: (sid, fid, filename) => `Stores(${sid})/Feeds(${fid})/GetUploadLink?fileName=${filename}`,
  uploadFeed: (sid, fid) => `Stores(${sid})/Feeds(${fid})/UploadFeed`,
  convertToImportFeed: (sid, fid) => `Stores(${sid})/Feeds(${fid})/ConvertToImportFeed`,
  deleteFeeds: sid => `Stores(${sid})/Feeds/DeleteFeeds`,
  getFeedLabelsByFeedId: (sid, fid) => `Stores(${sid})/Feeds(${fid})/GetFeedLabels`,
  getFeedLabels: sid => `Stores(${sid})/GetFeedLabels`,
  downloadlink: (sid, fid, feedUploadTrackerId, reportType) => `Stores(${sid})/Feeds(${fid})/GetDownloadLinks(FeedUploadTrackerId=${feedUploadTrackerId},ReportType=${reportType})`,
  getEvRejectionDistributionByFlagAreaIds: storeId => `Stores(${storeId})/EvRejectionDistributionByFlagAreaIds`,
  getEvRejectionDistributionByFlagAreaIdsPageByPage: storeId => `Stores(${storeId})/EvRejectionDistributionByFlagAreaIdsPageByPage`,
  getRejectedOffersForFlagAreaId: (storeId, flagAreaIdCode) => `Stores(${storeId})/RejectedOffersForFlagAreaId(flagAreaId='${flagAreaIdCode}')`,
  getRejectedOffersForFlagAreaIdPageByPage: (storeId, flagAreaIdCode) => `Stores(${storeId})/RejectedOffersForFlagAreaIdPageByPage(flagAreaId='${flagAreaIdCode}')`,
  getProductIssueDetails: (sid, issueCode) => `Stores(${sid})/GetProductIssueDetails(IssueCode='${issueCode}')`,
  getIssuesCount: sid => `Stores(${sid})/GetIssuesCount`,
  getProviderBootstrapData: sid => `Stores(${sid})/GetStoreBootstrapDataV2`,
  getNewProviderBootstrapData: sid => `Stores(${sid})/GetStoreBootstrapDataV3`,
  getProductOverviewChart: sid => `Stores(${sid})/GetProductsChart`,
  getProductPerformanceChart: sid => `Stores(${sid})/GetClicksImpressionsChart`,
  getProductListingsPerformanceChart: sid => `Stores(${sid})/GetProductListingsPerformanceChart`,
  isProductListingsPerformanceUXEnabled: storeId => `Stores(${storeId})/IsProductListingsPerformanceUXEnabled`,
  getStoreStatus: sid => `Stores(${sid})/GetStoreStatus`,
  getStorePilotFeatures: sid => `StorePilotFeatures?storeodatadtoId=${sid}`,
  getCustomerFraudStatus: sid => `Stores(${sid})/GetCustomerFraudStatus`,
  startStoreAppeal: sid => `Stores(${sid})/StartAppeal`,
  getStoreIssues: sid => `Stores(${sid})/GetStoreIssues`,
  getFeedIssues: sid => `Stores(${sid})/GetFeedIssues`,
  getProductIssues: sid => `Stores(${sid})/GetProductIssuesV2`,
  promotions: sid => `Stores(${sid})/Promotions`,
  gmcMerchants: sid => `Stores(${sid})/GmcMerchants/`,
  gmcMerchant: (sid, merchantid) => `Stores(${sid})/GMCMerchants('${merchantid}')/`,
  getGmcMerchants: (sid, domain) => `Stores(${sid})/GMCMerchants?domain='${domain}'`,
  getMarkets: sid => `Stores(${sid})/PromotionMarkets`,
  getPromotionTypes: 'PromotionTypes',
  getPilotFeatures: sid => `Stores(${sid})/features`,
  getPromotionStorage: sid => `Stores(${sid})/Promotions/GetStorage`,
  stopPromotion: sid => `Stores(${sid})/Promotions/stoppromotions`,
  retestPromotion: sid => `Stores(${sid})/Promotions/retestpromotions`,
  uploadPromotionFeed: sid => `Stores(${sid})/Promotions/UploadPromotionFeed`,
  getProductIssuesReportStatus: sid => `Stores(${sid})/GetProductIssuesReportStatus`,
  runProductIssuesReport: sid => `Stores(${sid})/RunProductIssuesReport`,
  downloadProductIssuesReport: sid => `Stores(${sid})/DownloadProductIssuesReport`,
  downloadStoreIssuesReport: (sid, issueCode, reportKey, market) => `Stores(${sid})/DownloadStoreIssuesReport(IssueCode='${issueCode}',ReportKey='${reportKey}', Market='${market}')`,
  ftpSettings: storeId => `Stores(${storeId})/FtpSettings`,
  automaticItemUpdateSettings: storeId => `Stores(${storeId})/AutomaticItemUpdateSettings`,
  shippingSettings: storeId => `Stores(${storeId})/ShippingSettings`,
  linkedManagerAccountsSettings: storeId => `Stores(${storeId})/LinkedManagerAccountsSettings`,
  downloadConsolidatedMatchedReport: storeId => `Stores(${storeId})/LinkedManagerAccountsSettings/LinkedCustomers/GetConsolidatedMatchedReportDownloadUrl`,
  downloadMatchedReport: (storeId, coOpInternalProviderId) => `Stores(${storeId})/LinkedManagerAccountsSettings/LinkedCustomers(${coOpInternalProviderId})/GetMatchedReportDownloadUrl`,
  acceptLinkedCustomerRequests: storeId => `Stores(${storeId})/LinkedManagerAccountsSettings/LinkedCustomers/AcceptCustomers`,
  declineLinkedCustomerRequests: storeId => `Stores(${storeId})/LinkedManagerAccountsSettings/LinkedCustomers/DeclineCustomers`,
  unlinkCustomers: storeId => `Stores(${storeId})/LinkedManagerAccountsSettings/LinkedCustomers/UnlinkCustomers`,
  linkedCustomerList: storeId => `Stores(${storeId})/LinkedManagerAccountsSettings/LinkedCustomers`,
  getProductListingsSettings: storeId => `Stores(${storeId})/ProductListingsSettings`,
  updateProductListingsSettings: storeId => `Stores(${storeId})/ProductListingsSettings`,
  submitAppeal: storeId => `Stores(${storeId})/SubmitAppeal`,
  getAllAggregators: () => 'Aggregators',
  getAggregatorsSettings: storeId => `Stores(${storeId})/AggregatorsSettings`,
  publishers: customerId => `Application/${customerId}/Publishers/`,
  imports: sid => `Stores(${sid})/Imports/`,
};
